import React from 'react';
import { Link } from 'react-router-dom';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import PhoneInput from 'react-phone-input-2';

import { FormValidate, InputContainer, Label, SuccessMessage, ErrorMessage, LoadingContainer, LinksRow } from './Auth.style';
import AuthHeader from './AuthHeader';
import { Button, CircularProgress } from '@material-ui/core';
import { TextMaskCustomPhone } from './TextMasks';
import { DefaultAuthContainer } from './AuthComponents';
import MainAuthComponent from './MainAuthComponent';

const Auth = ({
  isLoading,
  phone,
  setPhone,
  password,
  setPassword,
  isShowPassword,
  setIsShowPassword,
  isRememberMe,
  setIsRememberMe,
  isError,
  onClickAuth,
  successMessage,
  errorMessage,
}) => {
  return (
    <MainAuthComponent>
      <>
        <AuthHeader />
        <Label>Вход в личный кабинет пациента</Label>
        <FormValidate id="loginForm">
          <InputContainer>
            <PhoneInput
              country={'ru'}
              value={phone}
              onChange={(phone) => setPhone(phone)}
              autoFocus
              fullWidth
              variant="filled"
              id="phone"
              name="phone"
              placeholder="Телефон *"
              error={isError && !phone ? true : false}
              onKeyDown={onClickAuth}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onClickAuth();
                }
              }}
            />
          </InputContainer>
          <InputContainer>
            <Input
              id="password"
              name="password"
              type={isShowPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              variant="filled"
              // required
              label="Пароль *"
              placeholder="Пароль *"
              error={isError && !password ? true : false}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={() => setIsShowPassword(!isShowPassword)}>
                    {isShowPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onClickAuth();
                }
              }}
            />
          </InputContainer>
          {/* <InputContainer>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={isRememberMe}
                                  onChange={() => setIsRememberMe(event.target.checked)}
                                  name="rememberMe"
                                  color="primary"
                              />
                          }
                          label="Запомнить меня"
                      />
                  </InputContainer> */}
          <InputContainer>
            <Button variant="contained" color="secondary" fullWidth type="button" onClick={onClickAuth} size="large">
              Войти
              {isLoading && (
                <LoadingContainer>
                  <CircularProgress size={20} />
                </LoadingContainer>
              )}
            </Button>
          </InputContainer>
          <SuccessMessage>{successMessage}</SuccessMessage>
          <ErrorMessage>{errorMessage}</ErrorMessage>
          <InputContainer>
            <LinksRow>
              <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/register`}>
                <Button fullWidth type="button">
                  Регистрация
                </Button>
              </Link>
              |
              <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/forgot/1`}>
                <Button fullWidth type="button">
                  Забыли пароль
                </Button>
              </Link>
            </LinksRow>
          </InputContainer>
        </FormValidate>
      </>
    </MainAuthComponent>
  );
};

export default Auth;
